import React from "react";
import styled from "styled-components";
import { Logo } from "../../assets/images/Logo";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router-dom";

export const Home = () => {
  const { t } = useTranslation();

  return <Navigate to="/invitations" />;

  // eslint-disable-next-line no-unreachable
  return (
    <HomeContainer>
      <LogoContainer>
        <Logo />
      </LogoContainer>
      <Heading>{t("dashboard.welcomeDashboard")}</Heading>
    </HomeContainer>
  );
};

const HomeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

const LogoContainer = styled.div`
  width: 10rem;
`;

const Heading = styled.h1`
  font-size: 2.5rem;
`;
